import { computed } from "vue";
import { createMutation } from "@/mutations";
import { updateParameter, type UpdateParameterResponse } from "@/features/parameters/api/parameters";
import type { UpdateParameterPayload } from "@/types/parameters";
import type { MeasurementType } from "@/features/survey/types/survey-config";
import type { AxiosResponse } from "axios";

type UpdateParameterResponseType = Awaited<
  ReturnType<typeof updateParameter>
> extends AxiosResponse<infer T>
  ? T
  : never;

interface UpdateParameterVariables {
  measurementType: MeasurementType;
  payload: UpdateParameterPayload;
}

export const useUpdateParameterMutation = () => {
  return createMutation<UpdateParameterResponseType, UpdateParameterVariables>({
    mutationFn: async (variables) => {
      const response = await updateParameter(
        variables.measurementType,
        variables.payload
      );
      return response.data;
    },
    // the profile page (level conditions, "Мои размеры" card) is served by
    // user-profile/profile-data — a saved parameter must refresh it too, or
    // the counters go stale until a hard refresh (founder bug 2026-08-25).
    // The server re-matches the sizes from the measurements, so `sizes` too.
    invalidateQueries: (key) =>
      Array.isArray(key) &&
      (key[0] === "user-parameters" || key[0] === "user-profile" || key[0] === "sizes"),
  });
};

